<template>
  <layout style="background: #f5f5f5;" :title="$route.name" :options="options">
    <Filtros />
    <div
      v-if="get_relatorios.summary"
      class="report-summary expande-horizontal wrap"
    >
      <v-flex xs12 md3 class="pa-2">
        <v-card class="report-summary-card pa-4" elevation="1">
          <span class="fonte fonteMini grey--text">Faturamento bruto</span>
          <strong class="fonte">{{ formatMoney(get_relatorios.summary.gross_total) }}</strong>
        </v-card>
      </v-flex>
      <v-flex xs12 md3 class="pa-2">
        <v-card class="report-summary-card pa-4" elevation="1">
          <span class="fonte fonteMini grey--text">Taxas de pagamento</span>
          <strong class="fonte red--text">{{ formatMoney(get_relatorios.summary.payment_taxes_total) }}</strong>
        </v-card>
      </v-flex>
      <v-flex xs12 md3 class="pa-2">
        <v-card class="report-summary-card pa-4" elevation="1">
          <span class="fonte fonteMini grey--text">Impostos</span>
          <strong class="fonte red--text">{{ formatMoney(get_relatorios.summary.report_taxes_total) }}</strong>
        </v-card>
      </v-flex>
      <v-flex xs12 md3 class="pa-2">
        <v-card class="report-summary-card pa-4" elevation="1">
          <span class="fonte fonteMini grey--text">Liquido</span>
          <strong class="fonte green--text">{{ formatMoney(get_relatorios.summary.net_total) }}</strong>
        </v-card>
      </v-flex>
      <v-flex
        v-for="deduction in get_relatorios.summary.deductions"
        :key="deduction.id || deduction.nome"
        xs12
        md4
        class="pa-2"
      >
        <v-card class="report-deduction-card pa-3" elevation="0">
          <div>
            <strong class="fonte">{{ deduction.nome }}</strong>
            <span class="fonte fonteMini grey--text">
              {{ deduction.percentual }}% sobre {{ deduction.base === "net" ? "liquido" : "bruto" }}
            </span>
          </div>
          <strong class="fonte red--text">{{ formatMoney(deduction.value) }}</strong>
        </v-card>
      </v-flex>
    </div>

    <div
      v-if="get_relatorios.item_summary && get_relatorios.item_summary.length"
      class="report-summary expande-horizontal wrap px-2 pb-2"
    >
      <v-flex xs12 class="px-2 pt-1">
        <strong class="fonte fonteMini">Itens por categoria</strong>
      </v-flex>
      <v-flex
        v-for="item in get_relatorios.item_summary"
        :key="item.type"
        xs12
        sm6
        md3
        class="pa-2"
      >
        <v-card class="report-deduction-card pa-3" elevation="0">
          <div>
            <strong class="fonte">{{ item.type }}</strong>
            <span class="fonte fonteMini grey--text">
              {{ item.quantity }} unidade(s)
            </span>
          </div>
          <strong class="fonte">{{ formatMoney(item.total) }}</strong>
        </v-card>
      </v-flex>
    </div>

    <div
      v-if="card"
      class="expande-horizontal wrap"
      style="background: #f5f5f5;"
    >
      <VisualizacaoEmCard
        v-show="get_relatorios.docs.length > 0"
        v-for="payload in get_relatorios.docs"
        :key="payload.id"
        :payload="payload"
      />
    </div>

    <div v-else class="expande-horizontal wrap">
      <VisualizacaoEmLista v-show="get_relatorios.docs.length > 0" />
    </div>

    <ListagemVazia v-show="get_relatorios.docs.length === 0" />
    <Paginacao />
    <ModalView />

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      filename="proposta"
      :manual-pagination="true"
      pdf-format="a4"
      :pdf-quality="10"
      pdf-orientation="portrait"
      @progress="() => {}"
      @hasStartedGeneration="() => {}"
      @hasDownloaded="hasGenerated($event)"
      ref="html2Pdf"
    >
      <div slot="pdf-content">
        <section class="pdf-item">
          <div class="expande-horizontal centraliza coluna">
            <h1 class="font-weight-bold">{{ $route.name }}</h1>
            <!-- <h3 class=""> Polo: {{ getLoggedUser.tenant.nome }} </h3> -->
          </div>
          <div v-if="card" class="expande-horizontal centraliza pa-6 wrap">
            <VisualizacaoEmCard
              v-show="get_relatorios.docs.length > 0"
              v-for="payload in get_relatorios.data"
              :key="payload.id"
              :payload="payload"
            />
          </div>

          <div v-else class="expande-horizontal centraliza pa-6 wrap">
            <VisualizacaoEmLista v-show="get_relatorios.docs.length > 0" />
          </div>
        </section>
      </div>
    </vue-html2pdf>
  </layout>
</template>

<script>
import Filtros from "../components/Filtros.vue";
import VisualizacaoEmCard from "../components/VisualizacaoEmCard.vue";
import VisualizacaoEmLista from "../components/VisualizacaoEmLista.vue";
import Paginacao from "../components/Paginacao.vue";
import ListagemVazia from "../components/ListagemVazia.vue";
import ModalView from "../components/modalView.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      card: false,
      options: [
        // {
        //   icon: "mdi-plus",
        //   nome: "Novo relatorio",
        //   action: () => this.abre_modal_view_relatorio()
        // },
        {
          icon: "mdi-update",
          nome: "Atualizar",
          action: () => this.listar_relatorios()
        },
        {
          icon: "mdi-printer",
          nome: "Imprimir",
          action: () => this.imprimir()
        }
        // {
        //   icon: "mdi-ballot-outline",
        //   nome: "Visualizar em Lista",
        //   action: () => (this.card = false)
        // },
        // {
        //   icon: "mdi-post",
        //   nome: "Visualizar em Card",
        //   action: () => (this.card = true)
        // }
      ]
    };
  },
  components: {
    Filtros,
    VisualizacaoEmCard,
    VisualizacaoEmLista,
    Paginacao,
    ListagemVazia,
    ModalView
  },
  computed: {
    ...mapGetters(["get_relatorios", "get_relatorios_filtros", "getLoggedUser"])
  },
  methods: {
    ...mapActions([
      "abre_modal_view_relatorio",
      "listar_relatorios",
      "listar_relatoriocategorias"
    ]),
    imprimir() {
      this.card = false;
      this.$refs.html2Pdf.generatePdf();
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    }
  },
  created() {
    this.listar_relatorios();
    this.listar_relatoriocategorias();
  }
};
</script>

<style scoped>
.report-summary {
  padding: 0 16px 8px;
}
.report-summary-card {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 82px;
}
.report-summary-card strong {
  font-size: 20px;
}
.report-deduction-card {
  align-items: center;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
}
.report-deduction-card div {
  display: flex;
  flex-direction: column;
}
</style>
